import { useQuery } from '@tanstack/react-query';
import { getUserCases } from '../api/reportsApi';
import { msalInstance } from '@utils';

export const useReport = (reportId: string | undefined) => {
  return useQuery({
    queryKey: ['report', reportId],
    queryFn: async () => {
      if (!reportId) throw new Error('No report ID provided');
      const response = await getUserCases({ id: reportId });
      return response.cases[0] ?? null;
    },
    enabled: !!reportId && msalInstance.getAllAccounts().length > 0,
    staleTime: 30 * 1000,
  });
};
